"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const constellation_1 = require("@zillow/constellation");
const states_1 = require("../../types/states");
const RateSummaryModal_1 = __importDefault(require("./RateSummaryModal"));
const formatPercentage_1 = require("../../utils/formatPercentage");
const RateSummary = ({ state, principal, thirtyYearRate, thirtyYearApr, thirtyYearPoints, fifteenYearRate, fifteenYearApr, fifteenYearPoints, sevenYearArmRate, sevenYearArmApr, sevenYearArmPoints, }) => {
    const thirtyYearRateText = (0, formatPercentage_1.formatPercentage)(thirtyYearRate);
    const fifteenYearRateText = (0, formatPercentage_1.formatPercentage)(fifteenYearRate);
    const sevenYearArmRateText = (0, formatPercentage_1.formatPercentage)(sevenYearArmRate);
    const currentDate = new Date().toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    });
    const getLocationText = () => {
        if (state) {
            const stateName = (0, states_1.getStateName)(state);
            return `in ${stateName}`;
        }
        return '';
    };
    const getSummaryText = () => {
        const locationText = getLocationText();
        const baseText = `As of ${currentDate}, current 30-year fixed mortgage rates ${locationText} are ${thirtyYearRateText}, while current 15-year fixed mortgage rates ${locationText} are ${fifteenYearRateText}. For adjustable rates, like a 7-year ARM, rates are ${sevenYearArmRateText}.`;
        return baseText.replace(/\s{2,}/g, ' ').trim();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(constellation_1.Paragraph, { marginBottom: "sm" }, getSummaryText()),
        react_1.default.createElement(RateSummaryModal_1.default, { thirtyYearRateText: thirtyYearRateText, fifteenYearRateText: fifteenYearRateText, sevenYearArmRateText: sevenYearArmRateText, thirtyYearRate: thirtyYearRate || 0, thirtyYearApr: thirtyYearApr || 0, thirtyYearPoints: thirtyYearPoints || 0, fifteenYearRate: fifteenYearRate || 0, fifteenYearApr: fifteenYearApr || 0, fifteenYearPoints: fifteenYearPoints || 0, sevenYearArmRate: sevenYearArmRate || 0, sevenYearArmApr: sevenYearArmApr || 0, sevenYearArmPoints: sevenYearArmPoints || 0, principal: principal || 275000 })));
};
exports.default = RateSummary;
